<template>
    <div class="card">
        <div class="header">
            <h3>Servicer Interest Rate Details</h3>
            <a v-if="loanDetails.applicationUrl" :href="loanDetails.applicationUrl" target="_blank"> View Application </a>
        </div>
        <div class="item">
            <span class="label">Rate Type</span>
            <span class="dots"></span>
            <span class="value">{{ loanDetails.rateTypeHumanized }}</span>
        </div>
        <div class="item">
            <span class="label">Interest Rate</span>
            <span class="dots"></span>
            <span class="value">
                {{ loanDetails.servicerInterestRateFormatted }}
                <Popover>
                    <div class="interest-rate-popover">
                        <div class="item">
                            <span class="label">Index</span>
                            <span class="dots" />
                            <span class="value">{{ loanDetails.indexFormatted }}</span>
                        </div>
                        <div class="item">
                            <span class="label">Margin</span>
                            <span class="dots" />
                            <span class="value">{{ loanDetails.marginFormatted }}</span>
                        </div>
                        <div class="item">
                            <span class="label">Floor</span>
                            <span class="dots" />
                            <span class="value">{{ loanDetails.floorFormatted }}</span>
                        </div>
                        <div class="item">
                            <span class="label">Ceiling</span>
                            <span class="dots" />
                            <span class="value">{{ loanDetails.ceilingFormatted }}</span>
                        </div>
                    </div>
                </Popover>
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { defineProps } from 'vue';
    import Popover from '@/components/shared/Popover.vue';
    import { LoanDetails } from '@/models/loans';

    defineProps<{
        loanDetails: LoanDetails;
    }>();
</script>

<style scoped>
    .interest-rate-popover {
        width: 164px;
    }
</style>